export default __webpack_public_path__ + "static/media/citroen_offer1.a8860b65.jpg";